// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.0ffea45c.css";
	// return url for filenames based on template
	return "" + chunkId + "." + "2828339f" + ".chunk.css";
};